import { Nullable } from '@/shared/types/app.types'

export interface ConfigurationInsurersModalState {
    id: Nullable<number>
    name: string
    code: string
    email: string
    sendAuthorizations: boolean
    system: boolean
    active: boolean
}
export const initialConfigurationInsurersModalState =
    (): ConfigurationInsurersModalState => ({
        id: null,
        name: '',
        code: '',
        email: '',
        sendAuthorizations: false,
        system: false,
        active: true
    })
